'use client';
import React, { useState } from 'react';
import {
  CrossedPrice,
  Heading,
  PlanCard,
  PlanFeatures,
  Price,
  PriceContainer,
  Text,
  Title
} from '../styled';
import { PriceSpinner } from '../PriceSpinner';
import { ToggleSwitch } from '@/components/payments/ToggleSwitch';
import { LK } from '@/consts';

export const BusinessPlan = () => {
  const [isPerMonth, setIsPerMonth] = useState(true);
  const [priceValue, setPriceValue] = useState<string[]>(['', ',', '2', '9', '9']);

  return (
    <PlanCard>
      <Title>Business Plan</Title>
      <div>
        <Heading>Ideal for:</Heading>
        <Text>
          Growing businesses and SMEs in UAE Free Zones with moderate transaction volumes.
        </Text>
      </div>

      <div>
        <Heading>Features:</Heading>
        <PlanFeatures>
          <Text>
            Up to <b>3 companies</b> per account
          </Text>
          <Text>All Start Plan features, plus:</Text>
          <Text>AI-support, including AI-powered invoice generation</Text>
          <Text>24/7 support in English and Arabic in Accounting</Text>
          <Text>Automated integration with your CRM: Zoho, MS Dynamics, SalesForce.com, SAP</Text>
          <Text>Multi-currency support for international operations</Text>
        </PlanFeatures>
      </div>
      <div style={{ marginTop: 'auto' }} />
      <ToggleSwitch
        items={[
          { label: 'Monthly', value: 'monthly' },
          { label: 'Annual (Save 20%)', value: 'annual' }
        ]}
        value={isPerMonth ? 'monthly' : 'annual'}
        onChangeAction={(value) => {
          if (value === 'monthly') {
            setIsPerMonth(true);
            setPriceValue(['', ',', '2', '9', '9']);
          } else {
            setIsPerMonth(false);
            setPriceValue(['2', ',', '9', '9', '9']);
          }
        }}
      />
      <PriceContainer>
        <Price>
          <PriceSpinner value={priceValue} />
          <Title $fitContent>{isPerMonth ? '/month' : '/year'}</Title>
        </Price>

        <CrossedPrice>{isPerMonth ? 'AED 599/month' : 'AED 5,999/year'}</CrossedPrice>
      </PriceContainer>
      <a href={LK}>
        <button className="w-full transition hover:bg-gradient-white bg-gradient-custom hover:text-black text-white rounded-full text-center px-6 py-3 text-nowrap">
          Start now
        </button>
      </a>
    </PlanCard>
  );
};
